export default __webpack_public_path__ + "static/media/P306 zu P314.8dd95e38.mp3";